<template>
  <div id="app" v-show="show">
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {getToken} from '@/utils/cookie'
import {clearStore} from '@/utils/store'

export default {
  name: 'App',
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  created() {
    let loginType = this.$store.state.login.loginType
    /**
     * 若cookie为空而storage不为空，说明是重新打开的浏览器，清空缓存
     * 2025-11-14 增加限制：如果是365单点登录的，并且被365iframe嵌套时在同一浏览器打开了辅诊页面
     *                      清空token，让用户重新登录
     */
    if ((loginType === 'YZ365-SSO' && !this.isNestedInIframeCrossDomain()) || (!getToken() && this.$store.state.login.access_token)) {
      this.show = false
      clearStore()
      window.location.reload()
      console.info('清空缓存')
    } else {
      this.show = true
    }
  },
  methods: {
    isNestedInIframeCrossDomain() {
      try {
        // 尝试访问window.top，若跨域会抛出SecurityError
        // 若self !== top，说明被同域嵌套；若抛出异常，说明被跨域嵌套
        return window.self !== window.top
      } catch (e) {
        // 捕获到跨域异常 → 必然存在父窗口（否则不会有跨域限制）
        return true
      }
    }
  }

}
</script>
<style lang="scss">
#app {
  font-size: 16px;
}

/**
 * el-table全局样式修改，调整边框颜色
 */
// 内边距
.el-table--mini td, .el-table--mini th {
  /*padding: 0 0;*/
}

.el-table th {
  /*background: #E4E7ED;*/
  white-space: nowrap;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #606266;

  /deep/
  .gutter {
    display: table-cell !important;
  }
}

.el-table--border {
  border-top: 1px solid #d6d6d6;
  border-left: 1px solid #d6d6d6;
  border-right: 1px solid #d6d6d6;
  border-bottom: 1px solid #d6d6d6;
}

.el-table--border th, .el-table__fixed-right-patch {
  border-bottom: 1px solid #d6d6d6;
}

.el-table--border td,
.el-table--border th,
.el-table__body-wrapper
.el-table--border.is-scrolling-left
~ .el-table__fixed
.el-table
is-hidden {
  border-right: 1px solid #d6d6d6;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #d6d6d6;
}

.el-table--border th.gutter:last-of-type {
  border-bottom: 1px solid #ebeef5;
  border-bottom-width: 1px;
  border-right: 0px;
  background: #fff !important;
  display: block !important;
  width: 17px !important;
}

/*
 * el-radio 全局样式修改
 */
.el-radio-button__orig-radio:disabled:checked + .el-radio-button__inner {
  background-color: #999 !important;
}

.el-radio-button__orig-radio:disabled + .el-radio-button__inner {
  color: rgba(0, 0, 0, 0.8) !important;
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff !important;
  background-color: var(--theme-color) !important;
}

/**
 * el-select 全局样式修改
 */
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #999;
  cursor: not-allowed;
}

/********************  dialog在body显示时使用的样式  **************************/
//// table头部颜色
//.el-table th {
//  background: #F6F7FB !important;
//}
//
//// table当前选中行颜色
//.el-table__body tr.current-row > td {
//  background: #d9ecff !important;
//}

// tree当前选中行颜色
.el-tree--highlight-current {
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: var(--theme-color_light) !important;
  }
}

// dialog内边距
.el-dialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
}

.el-radio-group {
  .el-radio.is-bordered {
    border: 1px solid #cccccc;
  }

  .is-checked.el-radio__input.is-disabled + span.el-radio__label {
    color: #000000;
  }

  .is-checked.el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
    background-color: #000000;
  }
}

// 图片预览关闭按钮
div.el-image-viewer__wrapper {
  span.el-image-viewer__close {
    color: white !important;
  }
}

.el-message--success {
  background-color: var(--theme-color_light) !important;
  border-color: var(--theme-color) !important;

  .el-message__icon {
    color: var(--theme-color) !important;
  }

  .el-message__content {
    color: var(--theme-color) !important;
  }
}

.m_notify .el-notification__content {
  max-height: 300px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px; /* 设置滚动条的宽度 */
  }

  /* 设置滚动条的轨道（背景）样式 */
  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* 设置轨道的背景颜色 */
  }

  /* 设置滚动条的滑块（滚动条）样式 */
  &::-webkit-scrollbar-thumb {
    background: #888; /* 设置滑块的背景颜色 */
  }
}

// ******************** 全局message-box提示
.custom-messagebox-btn-class, .custom-messagebox-btn-class:hover, .custom-messagebox-btn-class:focus {
  color: #fff !important;
  border-color: #2762ff !important;
  background-color: #2762ff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue